module.exports = __webpack_public_path__ + "static/media/CXO-Outlook_Trade-marked.2c5942a9.png";